<ras-page>
	<main>
		<article *ngIf="article">
			<h1> {{ article.title }} </h1>
			<p class="dateline"> {{ article.date | date : 'd MMMM yyyy' }} </p>

			<aside class="recent">
				<h2>Recent news &amp; articles</h2>
				<article *ngFor="let article of articles">
					<h3><a [routerLink]="['/blog', article.slug]"> {{ article.title }} </a></h3>
					<p class="dateline"> {{ article.date | date : 'd MMMM yyyy' }} </p>
				</article>
			</aside>

			<img [src]="'https://rentastore.co.za' + article.picture" [alt]="article.alt">

			<div [innerHtml]="parse_markdown(article.body)"></div>

			<p> <a [routerLink]="['/blog']"> &#8592; Back</a> </p>
		</article>
	</main>
</ras-page>
